import React, { useState, useEffect } from 'react';
import QuizOptions from '@anu/components/QuizOptions';
import PropTypes from 'prop-types';
import { coursePropTypes } from '@anu/utilities/transform.course';
import {
  getStoredQuestion,
  setStoredQuestion,
} from '../utilities/session.question';

/**
 * Extends original `QuizOptionsHandler` to support private sessions.
 */
const QuizOptionsHandler = ({
  aqid,
  bundle,
  isQuiz,
  course,
  options,
  question,
  onChange,
  submittedAnswer,
  onQuestionComplete,
}) => {
  const [values, setValues] = useState(bundle === 'question_single_choice' ? null : []);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    if (isQuiz) {
      onChange(values);
    }
    // Check user session for lessons.
    else if (course && course.private_sessions) {
      const submittedAnswer = getStoredQuestion(aqid);
      if (submittedAnswer) {
        setValues(submittedAnswer);
        setIsSubmitted(false);
        onQuestionComplete(aqid);
      }
    }
  }, []);

  const handleCheckboxChange = (value, event) => {
    let newValues = [];
    const option = options.find(option => option.id === value);
    const checked = event.target.checked;

    // None of the above is clicked.
    if (option.type === 'single_multi_choice_none') {
      // If checked, we unselect the other options.
      if (checked) {
        newValues.push(value);
      }
    }
    // Regular options clicked.
    else {
      // Restore previous state.
      newValues = [...values];

      // Make sure "None of the above" is not selected.
      const noneOfTheAbove = options.find(
        (option) => option.type === 'single_multi_choice_none'
      );
      if (noneOfTheAbove && values.includes(noneOfTheAbove.id)) {
        newValues.splice(newValues.indexOf(value), 1);
      }

      if (checked && !values.includes(value)) {
        newValues.push(value);
      } else if (!checked && values.includes(value)) {
        newValues.splice(newValues.indexOf(value), 1);
      }
    }

    setValues(newValues);
    setIsSubmitted(true);
    setStoredQuestion(aqid, newValues);
    onQuestionComplete(aqid);
  };

  const handleRadioChange = (event) => {
    setValues(event.target.value);
    setStoredQuestion(aqid, event.target.value);
    onQuestionComplete(aqid);
  };

  return (
    <QuizOptions
      multipleOptions={bundle !== 'question_single_choice'}
      question={question}
      options={options}
      value={submittedAnswer || values}
      isSubmitted={isSubmitted}
      onChange={
        bundle === 'question_single_choice' ? handleRadioChange : handleCheckboxChange
      }
    />
  );
};

QuizOptionsHandler.propTypes = {
  course: coursePropTypes,
  onChange: PropTypes.func,
  bundle: PropTypes.string,
  isQuiz: PropTypes.bool,
  aqid: PropTypes.number,
  onQuestionComplete: PropTypes.func,
  question: PropTypes.string,
  options: PropTypes.array,
  submittedAnswer: PropTypes.string,
  correctQuizValue: PropTypes.string,
  isSubmitting: PropTypes.bool,
  isSubmitted: PropTypes.bool,
};

export default QuizOptionsHandler;
